import React from "react";
import { Tooltip, styled, tooltipClasses } from "@mui/material";

// Styled Tooltip component
const LightTooltip = styled(
  ({
    className,
    title,
    children,
    ...props
  }: {
    className?: string;
    title: React.ReactNode;
    children: React.ReactElement;
  }) => (
    <Tooltip {...props} classes={{ popper: className }} title={title}>
      {children}
    </Tooltip>
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[1],
    fontSize: 12,
    border: `1px solid ${theme.palette.divider}`,
  },
}));

export { LightTooltip };
